import React from "react"
import { Content } from "components/content/Content"
import { Image } from "components/image/Image"
import { PriceTier } from "./PriceTier"
import { ImageBuilder } from "_types/AssetsImage"
import { ButtonBuilder } from "_types/Button"
import { RichTextContent } from "_types/RichText"
import { SinglePriceTier } from "./price-tier-types"
import "./single-service.module.scss"
import { ButtonParser } from "components/button/ButtonParser"
import { ServiceIcon } from "assets/helper/icons"
import { AnchorNumber } from "components/anchor-number/AnchorNumber"
import { useGeneralSettings } from "hooks/useGeneralSettings"

interface SingleServiceProps {
  name?: string
  serviceFeatures?: RichTextContent
  ctaButton?: ButtonBuilder[]
  pestsCovered?: RichTextContent
  priceTerm?: string
  priceTiers?: SinglePriceTier
  featuredImage?: ImageBuilder
  servicePosition?: number
  isTabbedContent?: boolean
  isAltBlock?: boolean
  mapRuns?: number
  disclaimer?: string
  flag?: string
}

export const SingleService = ({
  name,
  serviceFeatures,
  ctaButton,
  pestsCovered,
  priceTerm,
  priceTiers,
  featuredImage,
  servicePosition,
  isTabbedContent = false,
  isAltBlock = false,
  mapRuns,
  disclaimer,
  flag,
}: SingleServiceProps) => {
  const { trackingNumbers } = useGeneralSettings()

  const mainOfficeTrackingNumber = trackingNumbers[0].trackingNumber
  const mainOfficePhoneNumber = trackingNumbers[0].phoneNumber

  const flagClass = flag && flag?.split(" ")[0].toLowerCase()

  return (
    <section className={`u-content-block-padding fr-container  single-service`}>
      <div className={`single-service__body u-flex  u-flex--col`}>
        <div
          className={`single-service__pricing-group u-flex--col u-flex-center-align`}
        >
          {flag && (
            <div className={`single-service__flag-banner ${flagClass}`}>
              <p className="single-service__flag">{flag}</p>
            </div>
          )}

          <div className={`u-flex--col u-flex-center-align`}>
            <ServiceIcon className={`single-service__icon ${flagClass}`} />
            {priceTiers && (
              <PriceTier
                priceTier={priceTiers.elements}
                priceTerm={priceTerm || "monthly"}
              />
            )}
            <div className="single-service__cta u-flex-center-align u-flex--col">
              {ctaButton && (
                <div className="single-service__buttons u-flex-center-align">
                  <ButtonParser
                    buttons={ctaButton}
                    extraClassNames="single-service__button"
                  />
                </div>
              )}

              <AnchorNumber
                phoneNumber={mainOfficePhoneNumber}
                trackingNumber={mainOfficeTrackingNumber}
                showIcon={false}
                label="or Call"
                baseClassName="contact"
                extraClassNames="u-flex-center-align"
              />
            </div>
          </div>
        </div>

        <div className="single-service__content-group u-flex--col  u-flex-center-align ">
          {serviceFeatures && serviceFeatures.value !== "<p><br></p>" && (
            <div className="single-service__content ">
              <Content content={serviceFeatures} />
            </div>
          )}
          {disclaimer && (
            <p className="single-service__disclaimer">{disclaimer}</p>
          )}
        </div>
      </div>
    </section>
  )
}
